<template>
  <div>
    <Content />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import Content from '@/components/LoginIdForgot.vue';

@Component({
  components: {
    Content,
  },
})
export default class LoginIdForgot extends Vue {}
</script>
